import { action } from 'satcheljs';
import type CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';

/**
 * Called when birthday calendar setting has been updated.
 * This action is listened by existing calendar module to update the state of selected calendars
 */
export const birthdayCalendarOptionUpdated = action(
    'birthdayCalendarOptionUpdated',
    (birthdayCalendarEnabled: boolean, serverResponse: CalendarActionResponse) => ({
        birthdayCalendarEnabled,
        serverResponse,
    })
);
